import { useCallback, useEffect, useState } from "react";
import { ActiveResponse } from "../../../../../services/decisionFlow";
import { CheckableValue } from "../../../../../components/checkable-list";
import { setQuery } from "../../../../../services/local-session-storage";

/** Estado e seleção da etapa de classes de ativos do wizard. */
export function useActivesSelect(actives: ActiveResponse[], onFinish: (actives: ActiveResponse[]) => void) {
    const [checkableValue, setCheckableValue] = useState<CheckableValue<ActiveResponse>[]>([]);

    const transformActives = useCallback(() => {
        const list = actives.map(
            (active) =>
                ({
                    value: active,
                    isSelected: false,
                } as CheckableValue<ActiveResponse>)
        );
        setCheckableValue(list);
    }, [actives]);

    useEffect(() => {
        transformActives();
    }, [transformActives]);

    const getSelectedItems = useCallback(
        () => checkableValue.filter((item) => item.isSelected).map((item) => item.value),
        [checkableValue]
    );

    const handleContinue = () => {
        setQuery({ actives: getSelectedItems() });
        onFinish(getSelectedItems());
    };

    const handleOnChange = useCallback(
        (value: ActiveResponse, isSelected: boolean) => {
            const newList = [...checkableValue];
            for (let i = 0; i < newList.length; i++) {
                if (newList[i].value.id === value.id) {
                    newList[i].isSelected = isSelected;
                    break;
                }
            }
            setCheckableValue(newList);
        },
        [checkableValue]
    );

    const clearAll = useCallback(() => {
        setCheckableValue((prev) => prev.map((item) => (item.isSelected ? { ...item, isSelected: false } : item)));
    }, []);

    const selectedCount = getSelectedItems().length;

    return {
        checkableValue,
        selectedCount,
        handleContinue,
        handleOnChange,
        clearAll,
    };
}
